export const nullImpl = null

export const undefinedImpl = undefined
